import MenuComponent from '../../Components/Masters/Menu/MenuComponent'

function MenuPage() {
    return (
        <MenuComponent/>
    )
}

export default MenuPage